<template>
	<section
		class="min-h-screen md:h-screen px-4 xl:px-28 flex flex-col items-center lg:flex-row lg:justify-between text-gray-500 bg-purple-900 bg-gradient-to-b from-gray-900 via-gray-900 to-purple-800 body-font">
		<div
			class="w-full max-w-xs h-auto px-6 py-8 md:place-self-center flex flex-col items-center justify-center bg-gray-700 bg-opacity-40 backdrop-filter backdrop-blur-lg shadow-2xl rounded-lg border border-gray-900">
			<!-- Avatar -->
			<img
				class="w-24 h-24 mb-3 rounded-full shadow-lg"
				:src="user.avatar"
				alt="Avatar" />
			<!-- Username -->
			<h5 class="mb-1 text-xl font-medium text-white dark:text-white">
				{{ user.username }}
			</h5>
			<!-- email -->
			<span class="text-sm text-gray-300 dark:text-gray-400">
				{{ user.email }}
			</span>
			<!-- Counts -->
			<div class="w-full flex justify-between text-gray-100">
				<button
					class="inline-flex py-3 px-3 mt-3 font-semibold rounded-lg items-center hover:bg-opacity-90 focus:outline-none">
					<p>{{ user.instrumentCount }}</p>
					<span class="ml-2 flex items-start flex-col leading-none">
						<span class="title-font font-medium">Instruments</span>
					</span>
				</button>
				<button
					class="inline-flex py-3 px-3 mt-3 font-semibold rounded-lg items-center hover:bg-opacity-90 focus:outline-none">
					<p>{{ user.bookCount }}</p>
					<span class="ml-2 flex items-start flex-col leading-none">
						<span class="title-font font-medium">BlackBooks</span>
					</span>
				</button>
			</div>
			<div class="w-full flex justify-between text-gray-100">
				<button
					class="inline-flex py-3 px-3 mt-3 font-semibold rounded-lg items-center hover:bg-opacity-90 focus:outline-none">
					<p>{{ user.paperCount }}</p>
					<span class="ml-2 flex items-start flex-col leading-none">
						<span class="title-font font-medium">PYQPapers&nbsp;</span>
					</span>
				</button>
				<button
					class="inline-flex py-3 px-3 mt-3 font-semibold rounded-lg items-center hover:bg-opacity-90 focus:outline-none">
					<p class="ml-1">{{ user.communityCount }}</p>
					<span class="ml-2 flex items-start flex-col leading-none">
						<span class="title-font font-medium">Community</span>
					</span>
				</button>
			</div>
			<!-- Profile Actions -->
			<div class="flex mt-4 space-x-3 md:mt-6">
				<span
					@click="logout()"
					class="inline-flex cursor-pointer items-center px-10 py-2 text-sm font-medium text-center text-gray-900 bg-purple-400 bg-opacity-80 rounded-lg hover:bg-opacity-75 focus:ring-4 focus:outline-none focus:ring-gray-200 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-700 dark:focus:ring-gray-700">
					Logout
				</span>
			</div>
		</div>

		<div class="container md:h-full px-5 my-8 mx-auto flex flex-col">
			<div class="flex mx-auto mt-8 flex-wrap justify-center mb-8 pager">
				<a
					@click="updateActiveId(1)"
					:class="
						activeID == 1
							? 'border-gray-500 text-white'
							: 'border-gray-800 text-gray-400 hover:text-white'
					"
					class="sm:px-6 py-3 w-1/2 flex-grow sm:w-auto cursor-pointer justify-center border-b-2 title-font font-medium inline-flex items-center leading-none tracking-wider">
					Instruments
				</a>
				<a
					@click="updateActiveId(2)"
					:class="
						activeID == 2
							? 'border-gray-500 text-white'
							: 'border-gray-800 text-gray-400 hover:text-white'
					"
					class="sm:px-6 py-3 w-1/2 flex-grow sm:w-auto cursor-pointer justify-center border-b-2 title-font font-medium inline-flex items-center leading-none tracking-wider">
					Black Books
				</a>
				<a
					@click="updateActiveId(3)"
					:class="
						activeID == 3
							? 'border-gray-500 text-white'
							: 'border-gray-800 text-gray-400 hover:text-white'
					"
					class="sm:px-6 py-3 w-1/2 flex-grow sm:w-auto cursor-pointer justify-center border-b-2 title-font font-medium inline-flex items-center leading-none tracking-wider">
					PYQ Papers
				</a>
				<a
					@click="updateActiveId(4)"
					:class="
						activeID == 4
							? 'border-gray-500 text-white'
							: 'border-gray-800 text-gray-400 hover:text-white'
					"
					class="sm:px-6 py-3 w-1/2 flex-grow sm:w-auto cursor-pointer justify-center border-b-2 title-font font-medium inline-flex items-center leading-none tracking-wider">
					Community
				</a>
			</div>
			<div
				id="step1"
				:class="activeID == 1 ? '' : 'hidden'"
				class="flex flex-col text-center w-full h-full">
				<h1 class="text-2xl font-medium title-font mb-4 text-white">
					Instruments
				</h1>
				<div
					v-if="user.instrumentCount"
					class="px-4 md:mb-32 w-full h-auto flex lg:flex-wrap gap-4 items-stretch lg:justify-center handleScroll cardDiv">
					<InstrumentCard
						v-for="item in instruments"
						:key="item._id"
						:id="item._id"
						:date="item.date"
						:available="item.sold"
						:contact="item.contact"
						:imageUrl="item.imageUrl"
						:material="item.instruments" />
				</div>
				<div v-else class="px-4 py-8 w-full flex flex-col items-center justify-center handleScroll cardDiv">
					<img class="w-96 h-96" src="@/assets/Empty-bro.png" alt="No items to display">
					<h2 class="text-lg text-white font-normal -mt-10">No items to display</h2>
				</div>
			</div>
			<!-- Books -->
			<div
				id="step2"
				:class="activeID == 2 ? '' : 'hidden'"
				class="flex flex-col text-center w-full h-full">
				<h1 class="text-2xl font-medium title-font mb-4 text-white">
					Black Books
				</h1>
				<div
					v-if="user.bookCount"
					class="px-4 py-8 w-full flex flex-wrap gap-4 items-stretch lg:justify-center handleScroll cardDiv">
					<BookCard
						v-for="item in books"
						:key="item._id"
						:id="item._id"
						:title="item.title"
						:date="item.publishedOn"
						:type="item.projectType"
						:report="item.report" />
				</div>
				<div v-else class="px-4 py-8 w-full flex flex-col items-center justify-center handleScroll cardDiv">
					<img class="w-96 h-96" src="@/assets/Empty-bro.png" alt="No items to display">
					<h2 class="text-lg text-white font-normal -mt-10">No items to display</h2>
				</div>
			</div>
			<!-- Papers -->
			<div
				id="step3"
				:class="activeID == 3 ? '' : 'hidden'"
				class="flex flex-col text-center w-full h-full">
				<h1 class="text-2xl font-medium title-font mb-4 text-white">
					PYQ Papers
				</h1>
				<div
					v-if="user.paperCount"
					class="px-4 py-8 w-full flex flex-wrap gap-4 items-stretch lg:justify-center handleScroll cardDiv">
					<PaperCard
						v-for="item in papers"
						:key="item._id"
						:id="item._id"
						:paper="item.paper"
						:branch="item.branch"
						:semester="item.semester"
						:year="Math.ceil(Number(item.semester.substring(0, 1)) / 2)"
						:subject="item.subject" />
				</div>
				<div v-else class="px-4 py-8 w-full flex flex-col items-center justify-center handleScroll cardDiv">
					<img class="w-96 h-96" src="@/assets/Empty-bro.png" alt="No items to display">
					<h2 class="text-lg text-white font-normal -mt-10">No items to display</h2>
				</div>
			</div>
			<!-- Community -->
			<div
				id="step4"
				:class="activeID == 4 ? '' : 'hidden'">
				<div class="flex flex-col text-center w-full">
					<h1 class="text-2xl font-medium title-font mb-4 text-white">
						Community
					</h1>
					<div
						class="px-4 py-8 w-full flex flex-wrap gap-4 items-stretch lg:justify-center handleScroll cardDiv">
						<div v-if="user.communityCount">
							Community
						</div>
						<div v-else>
							<img class="w-96 h-96" src="@/assets/Empty-bro.png" alt="No items to display">
							<h2 class="text-lg text-white font-normal -mt-10">No items to display</h2>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<style scoped>
.handleScroll::-webkit-scrollbar {
	width: 0em;
}

.cardDiv {
	overflow-x: auto;
	overflow-y: hidden;
}

@media (min-width: 1024px) {
	.cardDiv {
		overflow-x: hidden;
		overflow-y: auto;
	}
}
</style>

<script>
import Vue from 'vue'
import axios from 'axios'
import { store } from '@/components/store'
import toonAvatar from 'cartoon-avatar'
import BookCard from '@/components/Cards/BookCard.vue'
import PaperCard from '@/components/Cards/PaperCard.vue'
import InstrumentCard from '@/components/Cards/InstrumentCard.vue'

export default {
	name: 'Profile',
	components: {
		BookCard,
		PaperCard,
		InstrumentCard
	},
	data() {
		return {
			user: {
				username: 'john doe',
				email: 'johndoe@gmail.com',
				instrumentCount: 0,
				bookCount: 0,
				paperCount: 0,
				communityCount: 0,
				avatar: toonAvatar.generate_avatar()
			},
			instruments: [],
			books: [],
			papers: [],
			communities: [],
			activeID: 1
		}
	},
	async mounted() {
		const userData = await axios.get('api/user')
		this.user.email = userData.data.email
		this.user.username = userData.data.username
		const instruments = await axios.get('api/myInstruments')
		this.instruments = instruments.data
		this.user.instrumentCount = this.instruments.length
		const books = await axios.get('api/myBooks')
		this.books = books.data
		this.user.bookCount = this.books.length
		const papers = await axios.get('api/myPapers')
		this.papers = papers.data
		this.user.paperCount = this.papers.length
		this.$forceUpdate()
	},
	methods: {
		updateActiveId(id) {
			this.activeID = id
		},
		logout() {
			store.loggedIn = false
			localStorage.removeItem('token')
			this.$router.push('/login')
			Vue.$toast.success('Logged out successfully', { position: 'top' })
		}
	}
}
</script>
